import { isCarvanaNativeApp } from '@carvana/core-native-messaging';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect } from 'react';
import { useGlobalStore } from '@/stores/global-store';
import styles from './Footer.module.css';

const FooterContent = () => {
  const setFooterLoaded = useGlobalStore((state) => state.setFooterLoaded);

  useEffect(() => {
    void MfeLoad({
      files: [
        [
          'FooterModule',
          [
            {
              component: 'default',
              default: {
                file: 'index.js',
                manifest: `${process.env.ASSETS_CDN_URL}/footer/module/assets-manifest.json?v=${crypto.randomUUID()}`,
              },
            },
          ],
        ],
      ],
    });
  }, []);

  return (
    <MfeReactComponent
      component="default"
      module="FooterModule"
      className={styles.footer}
      loading={<div className={styles.placeholder} />}
      onComponentLoaded={() => {
        setFooterLoaded(true);
      }}
    />
  );
};

export const Footer = () => {
  if (isCarvanaNativeApp()) return null;

  return <FooterContent />;
};
